import { createFileRoute } from '@tanstack/react-router';

import { PluginsTable } from 'component/partial/tables/plugins/PluginsTable';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/plugins/')({
  component: PluginsIndexRoute,
});

function PluginsIndexRoute() {
  return <PluginsTable />;
}
